import { render, staticRenderFns } from "./QuickSight.vue?vue&type=template&id=c4db67aa&"
import script from "./QuickSight.vue?vue&type=script&lang=js&"
export * from "./QuickSight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports